import React from 'react';
import Settings from '../components/settings/Settings';

const SettingsView = () => {
    return (
        <div>
            <Settings />
        </div>
    );
};

export default SettingsView;